import React, { useState } from 'react';

const EmployesModuleFonctionnel = () => {
  const [employes, setEmployes] = useState([
    { id: 1, nom: 'Marie BIOKOU', poste: 'Chef Comptabilité', email: 'marie@fhcgroupe.com', tel: '+229 XX XX XX', departement: 'Comptabilité', statut: 'actif', dateEmbauche: '2023-01-15' },
    { id: 2, nom: 'Sophie DOSSOU', poste: 'Comptable', email: 'sophie@fhcgroupe.com', tel: '+229 XX XX XX', departement: 'Comptabilité', statut: 'actif', dateEmbauche: '2023-06-01' },
    { id: 3, nom: 'Jean KOFFI', poste: 'Assistant Comptable', email: 'jean@fhcgroupe.com', tel: '+229 XX XX XX', departement: 'Comptabilité', statut: 'actif', dateEmbauche: '2024-02-10' }
  ]);

  const [taches, setTaches] = useState([
    { id: 1, titre: 'Clôture mensuelle mai 2026', employe: 'Sophie DOSSOU', dateDebut: '2026-06-01', dateFin: '2026-06-05', statut: 'termine', priorite: 'haute' },
    { id: 2, titre: 'Vérification factures fournisseurs', employe: 'Jean KOFFI', dateDebut: '2026-06-10', dateFin: '2026-06-15', statut: 'en_cours', priorite: 'normale' },
    { id: 3, titre: 'Préparation déclarations fiscales', employe: 'Sophie DOSSOU', dateDebut: '2026-06-20', dateFin: '2026-06-30', statut: 'planifie', priorite: 'haute' }
  ]);

  const [modalOpen, setModalOpen] = useState('');
  const [formData, setFormData] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [activeTab, setActiveTab] = useState('employes');

  const openModal = (type, item = null) => {
    setModalOpen(type);
    if (item) {
      setEditingId(item.id);
      setFormData(item);
    } else {
      setEditingId(null);
      setFormData({});
    }
  };

  const closeModal = () => {
    setModalOpen('');
    setEditingId(null);
    setFormData({});
  };

  // CRUD Employés
  const saveEmploye = () => {
    if (!formData.nom || !formData.poste || !formData.email) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }

    if (editingId) {
      setEmployes(employes.map(e => e.id === editingId ? { ...formData, id: editingId } : e));
    } else {
      setEmployes([...employes, { ...formData, id: Date.now(), statut: 'actif', dateEmbauche: new Date().toISOString().split('T')[0] }]);
    }
    closeModal();
  };

  const deleteEmploye = (id) => {
    if (window.confirm('Supprimer cet employé ? Cette action est irréversible.')) {
      setEmployes(employes.filter(e => e.id !== id));
      // Supprimer aussi les tâches assignées
      setTaches(taches.filter(t => t.employe !== employes.find(e => e.id === id)?.nom));
    }
  };

  // CRUD Tâches
  const saveTache = () => {
    if (!formData.titre || !formData.employe || !formData.dateDebut || !formData.dateFin) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }

    if (editingId) {
      setTaches(taches.map(t => t.id === editingId ? { ...formData, id: editingId } : t));
    } else {
      setTaches([...taches, { ...formData, id: Date.now(), statut: 'planifie' }]);
    }
    closeModal();
  };

  const deleteTache = (id) => {
    if (window.confirm('Supprimer cette tâche ?')) {
      setTaches(taches.filter(t => t.id !== id));
    }
  };

  const styles = {
    container: { padding: '24px', background: '#060d18', minHeight: '100vh', fontFamily: 'DM Sans, sans-serif' },
    header: { marginBottom: 24 },
    title: { fontFamily: 'Cormorant Garamond, serif', fontSize: 28, fontWeight: 600, color: '#fff', marginBottom: 6 },
    subtitle: { fontSize: 13, color: 'rgba(255,255,255,0.4)' },
    tabs: { display: 'flex', gap: 4, marginBottom: 24, borderBottom: '1px solid rgba(255,255,255,0.07)' },
    tab: { padding: '12px 20px', fontSize: 13, fontWeight: 500, cursor: 'pointer', borderBottom: '2px solid transparent', transition: 'all 0.2s' },
    card: { background: '#0d1825', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 12, padding: '18px 20px', marginBottom: 14 },
    cardTitle: { fontSize: 14, fontWeight: 600, color: '#fff', marginBottom: 10 },
    cardMeta: { fontSize: 11, color: '#667', display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 12 },
    badge: { fontSize: 10, fontWeight: 600, padding: '3px 10px', borderRadius: 99, display: 'inline-block' },
    btn: { background: '#C9A84C', border: 'none', borderRadius: 8, padding: '9px 18px', color: '#1a1a0d', fontSize: 12, fontWeight: 600, cursor: 'pointer' },
    btnSecondary: { background: 'transparent', border: '1.5px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '8px 16px', color: '#888', fontSize: 11, cursor: 'pointer' },
    btnDanger: { background: 'rgba(239,83,80,0.1)', border: '1px solid rgba(239,83,80,0.3)', borderRadius: 7, padding: '6px 12px', color: '#ef8080', fontSize: 11, cursor: 'pointer' },
    modal: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
    modalContent: { background: '#0d1825', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 14, padding: 24, width: 550, maxHeight: '85vh', overflowY: 'auto' },
    modalTitle: { fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#fff', marginBottom: 20 },
    field: { marginBottom: 14 },
    label: { fontSize: 11, fontWeight: 600, color: '#8a9bb0', marginBottom: 6, display: 'block', textTransform: 'uppercase', letterSpacing: 0.5 },
    input: { width: '100%', background: 'rgba(255,255,255,0.05)', border: '1.5px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '10px 12px', color: '#fff', fontSize: 13, outline: 'none' }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.title}>👥 Gestion des Employés</div>
        <div style={styles.subtitle}>CRUD employés & assignation des tâches</div>
      </div>

      {/* TABS */}
      <div style={styles.tabs}>
        <div
          style={{
            ...styles.tab,
            color: activeTab === 'employes' ? '#C9A84C' : '#667',
            borderBottomColor: activeTab === 'employes' ? '#C9A84C' : 'transparent'
          }}
          onClick={() => setActiveTab('employes')}
        >
          👥 Employés ({employes.length})
        </div>
        <div
          style={{
            ...styles.tab,
            color: activeTab === 'taches' ? '#C9A84C' : '#667',
            borderBottomColor: activeTab === 'taches' ? '#C9A84C' : 'transparent'
          }}
          onClick={() => setActiveTab('taches')}
        >
          📋 Tâches ({taches.length})
        </div>
      </div>

      {/* TAB EMPLOYÉS */}
      {activeTab === 'employes' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <div style={{ fontSize: 15, fontWeight: 600, color: '#fff' }}>
              Liste des employés ({employes.length})
            </div>
            <button style={styles.btn} onClick={() => openModal('employe')}>
              + Ajouter un employé
            </button>
          </div>

          {employes.map(employe => (
            <div key={employe.id} style={styles.card}>
              <div style={styles.cardTitle}>{employe.nom}</div>
              <div style={styles.cardMeta}>
                <span>💼 {employe.poste}</span>
                <span>🏢 {employe.departement}</span>
                <span>📧 {employe.email}</span>
                <span>📱 {employe.tel}</span>
                <span>📅 Embauché le {employe.dateEmbauche}</span>
                <span style={{
                  ...styles.badge,
                  background: employe.statut === 'actif' ? 'rgba(76,175,80,0.15)' : 'rgba(239,83,80,0.15)',
                  color: employe.statut === 'actif' ? '#66bb6a' : '#ef8080'
                }}>
                  {employe.statut === 'actif' ? '✅ Actif' : '❌ Inactif'}
                </span>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button style={styles.btnSecondary} onClick={() => openModal('employe', employe)}>
                  ✏️ Modifier
                </button>
                <button style={styles.btnSecondary} onClick={() => openModal('tache', { employe: employe.nom })}>
                  📋 Assigner tâche
                </button>
                <button style={styles.btnDanger} onClick={() => deleteEmploye(employe.id)}>
                  🗑️ Supprimer
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* TAB TÂCHES */}
      {activeTab === 'taches' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <div style={{ fontSize: 15, fontWeight: 600, color: '#fff' }}>
              Liste des tâches ({taches.length})
            </div>
            <button style={styles.btn} onClick={() => openModal('tache')}>
              + Nouvelle tâche
            </button>
          </div>

          {taches.map(tache => (
            <div key={tache.id} style={styles.card}>
              <div style={styles.cardTitle}>{tache.titre}</div>
              <div style={styles.cardMeta}>
                <span>👤 {tache.employe}</span>
                <span>📅 Du {tache.dateDebut} au {tache.dateFin}</span>
                <span style={{
                  ...styles.badge,
                  background: tache.priorite === 'haute' ? 'rgba(239,83,80,0.15)' : tache.priorite === 'normale' ? 'rgba(66,165,245,0.15)' : 'rgba(255,255,255,0.1)',
                  color: tache.priorite === 'haute' ? '#ef8080' : tache.priorite === 'normale' ? '#64b5f6' : '#888'
                }}>
                  {tache.priorite === 'haute' ? '🔴 Haute' : tache.priorite === 'normale' ? '🟠 Normale' : '⚪ Basse'}
                </span>
                <span style={{
                  ...styles.badge,
                  background: tache.statut === 'termine' ? 'rgba(76,175,80,0.15)' : tache.statut === 'en_cours' ? 'rgba(66,165,245,0.15)' : 'rgba(255,152,0,0.15)',
                  color: tache.statut === 'termine' ? '#66bb6a' : tache.statut === 'en_cours' ? '#64b5f6' : '#ffb74d'
                }}>
                  {tache.statut === 'termine' ? '✅ Terminé' : tache.statut === 'en_cours' ? '🔄 En cours' : '⏳ Planifié'}
                </span>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button style={styles.btnSecondary} onClick={() => openModal('tache', tache)}>
                  ✏️ Modifier
                </button>
                <button style={styles.btnDanger} onClick={() => deleteTache(tache.id)}>
                  🗑️ Supprimer
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* MODAL EMPLOYÉ */}
      {modalOpen === 'employe' && (
        <div style={styles.modal} onClick={closeModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalTitle}>
              {editingId ? '✏️ Modifier l\'employé' : '➕ Nouvel employé'}
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Nom complet *</label>
              <input
                style={styles.input}
                value={formData.nom || ''}
                onChange={(e) => setFormData({...formData, nom: e.target.value})}
                placeholder="Ex: Sophie DOSSOU"
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <div style={styles.field}>
                <label style={styles.label}>Poste *</label>
                <input
                  style={styles.input}
                  value={formData.poste || ''}
                  onChange={(e) => setFormData({...formData, poste: e.target.value})}
                  placeholder="Ex: Comptable"
                />
              </div>
              <div style={styles.field}>
                <label style={styles.label}>Département</label>
                <input
                  style={styles.input}
                  value={formData.departement || ''}
                  onChange={(e) => setFormData({...formData, departement: e.target.value})}
                  placeholder="Ex: Comptabilité"
                />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <div style={styles.field}>
                <label style={styles.label}>Email *</label>
                <input
                  type="email"
                  style={styles.input}
                  value={formData.email || ''}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  placeholder="email@fhcgroupe.com"
                />
              </div>
              <div style={styles.field}>
                <label style={styles.label}>Téléphone</label>
                <input
                  style={styles.input}
                  value={formData.tel || ''}
                  onChange={(e) => setFormData({...formData, tel: e.target.value})}
                  placeholder="+229 XX XX XX XX"
                />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <div style={styles.field}>
                <label style={styles.label}>Date d'embauche</label>
                <input
                  type="date"
                  style={styles.input}
                  value={formData.dateEmbauche || ''}
                  onChange={(e) => setFormData({...formData, dateEmbauche: e.target.value})}
                />
              </div>
              <div style={styles.field}>
                <label style={styles.label}>Statut</label>
                <select
                  style={styles.input}
                  value={formData.statut || 'actif'}
                  onChange={(e) => setFormData({...formData, statut: e.target.value})}
                >
                  <option value="actif">Actif</option>
                  <option value="inactif">Inactif</option>
                  <option value="conge">En congé</option>
                </select>
              </div>
            </div>

            <div style={{ marginTop: 20, display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button style={styles.btnSecondary} onClick={closeModal}>Annuler</button>
              <button style={styles.btn} onClick={saveEmploye}>
                {editingId ? '💾 Enregistrer' : '➕ Créer'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL TÂCHE */}
      {modalOpen === 'tache' && (
        <div style={styles.modal} onClick={closeModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalTitle}>
              {editingId ? '✏️ Modifier la tâche' : '➕ Nouvelle tâche'}
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Titre *</label>
              <input
                style={styles.input}
                value={formData.titre || ''}
                onChange={(e) => setFormData({...formData, titre: e.target.value})}
                placeholder="Ex: Clôture mensuelle mai 2026"
              />
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Assigné à *</label>
              <select
                style={styles.input}
                value={formData.employe || ''}
                onChange={(e) => setFormData({...formData, employe: e.target.value})}
              >
                <option value="">-- Sélectionner un employé --</option>
                {employes.map(emp => (
                  <option key={emp.id} value={emp.nom}>{emp.nom} - {emp.poste}</option>
                ))}
              </select>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <div style={styles.field}>
                <label style={styles.label}>Date début *</label>
                <input
                  type="date"
                  style={styles.input}
                  value={formData.dateDebut || ''}
                  onChange={(e) => setFormData({...formData, dateDebut: e.target.value})}
                />
              </div>
              <div style={styles.field}>
                <label style={styles.label}>Date fin *</label>
                <input
                  type="date"
                  style={styles.input}
                  value={formData.dateFin || ''}
                  onChange={(e) => setFormData({...formData, dateFin: e.target.value})}
                />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <div style={styles.field}>
                <label style={styles.label}>Priorité</label>
                <select
                  style={styles.input}
                  value={formData.priorite || 'normale'}
                  onChange={(e) => setFormData({...formData, priorite: e.target.value})}
                >
                  <option value="haute">Haute</option>
                  <option value="normale">Normale</option>
                  <option value="basse">Basse</option>
                </select>
              </div>
              <div style={styles.field}>
                <label style={styles.label}>Statut</label>
                <select
                  style={styles.input}
                  value={formData.statut || 'planifie'}
                  onChange={(e) => setFormData({...formData, statut: e.target.value})}
                >
                  <option value="planifie">Planifié</option>
                  <option value="en_cours">En cours</option>
                  <option value="termine">Terminé</option>
                </select>
              </div>
            </div>

            <div style={{ marginTop: 20, display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button style={styles.btnSecondary} onClick={closeModal}>Annuler</button>
              <button style={styles.btn} onClick={saveTache}>
                {editingId ? '💾 Enregistrer' : '➕ Créer'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployesModuleFonctionnel;
